module.exports = __webpack_public_path__ + "img/mixer@3x.58c6d78e.png";